import { baseTheme } from '@streamlain/theme';

export const edgelessCanvasBackgroundVar =
  '--streamlain-edgeless-canvas-background-color';
export const edgelessCanvasGridColorVar =
  '--streamlain-edgeless-canvas-grid-color';
export const minimapPanelBackgroundVar =
  '--streamlain-minimap-panel-background';
export const minimapPanelBorderColorVar =
  '--streamlain-minimap-panel-border-color';
export const minimapPanelBorderRadiusVar =
  '--streamlain-minimap-panel-border-radius';
export const minimapPanelBorderWidthVar =
  '--streamlain-minimap-panel-border-width';
export const minimapPanelShadowVar = '--streamlain-minimap-panel-shadow';
export const minimapControlColorVar = '--streamlain-minimap-control-color';

export const minimapPanelBackground = `var(${minimapPanelBackgroundVar}, var(${edgelessCanvasBackgroundVar}, var(--streamlain-v2-layer-background-secondary, var(--streamlain-v2-layer-background-secondary))))`;
export const minimapPanelBorderColor = `var(${minimapPanelBorderColorVar}, color-mix(in srgb, var(--streamlain-v2-button-primary, var(--streamlain-v2-brand-primary)) 34%, transparent))`;
export const minimapPanelBorderRadius = `var(${minimapPanelBorderRadiusVar}, 8px)`;
export const minimapPanelBorderWidth = `var(${minimapPanelBorderWidthVar}, 1px)`;
export const minimapPanelBorder = `${minimapPanelBorderWidth} solid ${minimapPanelBorderColor}`;
export const minimapPanelShadow = `var(${minimapPanelShadowVar}, var(--streamlain-v2-shadow-level2))`;
export const minimapPanelBoxSizing = 'border-box';
/** Corner radius in px of a map's large overview at full size (canvas and workflow builder). */
export const MAXIMAP_RADIUS = 16;
/** The dim behind a map's large overview. */
export const maximapBackdrop = 'rgb(0 0 0 / 55%)';

/** Thickness in px of a canvas ruler at full size. */
export const CANVAS_RULER_THICKNESS = 18;

// The dock clears the top ruler, and keeps the same room to the view's end.
export const minimapDockTop = `${CANVAS_RULER_THICKNESS}px`;
export const minimapDockRight = `${CANVAS_RULER_THICKNESS}px`;
export const minimapDockGap = '8px';
export const minimapDockWidth = '180px';
export const minimapDockWidthMedium = '220px';
export const minimapDockWidthLarge = '260px';
export const minimapCanvasHeight = '120px';
export const minimapCanvasHeightMedium = '140px';
export const minimapCanvasHeightLarge = '160px';

export const minimapControlGap = '4px';
export const minimapControlSize = '32px';
export const minimapControlIconSize = '24px';
export const minimapControlPaddingValue = 4;
export const minimapControlPadding = '4px';
export const minimapControlBoxSizing = 'border-box';
export const minimapControlAppearance = 'none';
export const minimapControlMargin = '0';
export const minimapControlTextAlign = 'center';
export const minimapControlBorder = 'none';
export const minimapControlBorderRadius = '4px';
export const minimapControlBackground = 'transparent';
export const minimapControlColor = `var(${minimapControlColorVar}, var(--streamlain-v2-icon-primary))`;
export const minimapControlHoverColor = 'var(--streamlain-v2-brand-primary)';
export const minimapControlHoverBackground =
  'var(--streamlain-v2-layer-background-hoverOverlay)';
export const minimapControlFocusOutline = `2px solid ${minimapControlHoverColor}`;
export const minimapControlFontFamily = baseTheme.fontSansFamily;
export const minimapControlFontSize = '12px';
export const minimapControlFontStyle = 'normal';
export const minimapControlFontWeight = '500';
export const minimapControlFontFeatureSettings = 'normal';
export const minimapControlLineHeight = 'normal';
export const minimapZoomPercentWidth = '40px';
